import { createAction } from '@mendeley-internal/lib-js-redux-actions';
import api from '../services/api/request';

export const getMyProfile = createAction(
  'GET_MY_PROFILE',
  () => api.get('profiles/me')
);



// WEBPACK FOOTER //
// ./src/universal/ui/actions/profile.js